import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import MonthName from "./MonthName";
import { Thai } from "flatpickr/dist/l10n/th.js";

import ModalCardLeave from "./ModalCardLeave";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import ModalSummaryLeaveDay from "./ModalSummaryLeaveDay";
import axios from "axios";
import Bookcertificate from "../PDFFIle/Bookcertificate";
import Lottie from "react-lottie";
import * as loadingLeaveTap from "../../../assets/lottieAnimation/loadingLeaveTap.json";
import { CheckPosition } from "../../Function/CheckPosition";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";
import SelectOrg from "../../EntryWork/selectOrg/selectOrg";

const SelectReport = ({ idReport, getUserEmployee, budgetYear }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;
  const cont_to_id = userPosition[0]?.org_id;

  const [searchData, setSearchData] = useState({
    startDate: new Date(),
    toDate: new Date(),
    department: "",
    groupName: "",
    empName: "",
    empNamID: "",
    fileType: "1",
    reportType: "1",
  });

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [userSummary, setUserSummary] = useState(null);
  const [budgetForDefault, setBudgetForDefault] = useState(null);
  const [leaveTypeHistory, setLeaveTypeHistory] = useState(null);
  const [leaveTypeLeaveCounting, setLeaveTypeLeaveCounting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal3, setModal3] = useState(false);
  const [modalORG, setModalORG] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [orgInnerKong, setOrgInnerKong] = useState([]);
  const [orgInnerGroup, setOrgInnerGroup] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [enterKeyword, setEnterKeyword] = useState("");
  const [checkDisbleButton, setCheckDisbleButton] = useState(false)

  const [cardLeave, setCardLeave] = useState(false);
  const handleOpenCardLeave = () => {
    setCardLeave(!cardLeave);
  };

  const [searchReport, setSearchReport] = useState({
    budget_year: "",
    fromDate: "",
    toDate: "",
    month: "",
    report_type: "",
    employeeType: "",
    groupType: "",
    employeeId: "",
    employeeName: "",
  });

  const [selectEmp, setSelectEmp] = useState({
    id: "",
    name: "",
  });

  useEffect(() => {
    setLoading(true)
      setSearchReport((prev) => ({
        ...prev,
        budget_year: budgetYear,
        fromDate: "",
        toDate: "",
        month: "",
        // month: MonthName[new Date().getMonth()].no,
        report_type: "",
        employeeType: "",
        groupType: "",
        employeeId: "",
        employeeName: "",
      }));
      setSearchData({
        startDate: new Date(),
        toDate: new Date(),
        department: "",
        groupName: "",
        empName: "",
        empNamID: "",
        fileType: "1",
        reportType: "1",
      });
      getEmployee();
    setTimeout(() => {
      setLoading(false);
    }, 1800);
  }, [idReport]);

  const [modalSummaryLeaveDay, setModalSummaryLeaveDay] = useState(false);
  const toggleModalSummaryLeaveDayOpen = () => {
    // leaveSummaryHistoryStatus();
    setModalSummaryLeaveDay(!modalSummaryLeaveDay);
  };
  const toggleModalSummaryLeaveDay = () => {
    setLeaveTypeHistory(null);
    setLeaveTypeLeaveCounting(null);
    setUserSummary(null);
    setModalSummaryLeaveDay(!modalSummaryLeaveDay);
  };

  const [orgInner, setOrgInner] = useState([]);
  const getOrgInnerLevel = async () => {
    try {
      const res = await axios.get(baseURL + "/api/orgInner/level", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOrgInner(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const [userInfo, setUserInfo] = useState([]);
  const getUserInfo = async () => {
    try {
      const res = await axios.get(baseURL + "/api/users/info", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserInfo(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const [childSelect, setChildSelect] = useState(false);
  const toggleChildSelect = () => {
    setChildSelect(!childSelect);
  };
  const [childSelect2, setChildSelect2] = useState(false);
  const toggleChildSelect2 = () => {};

  const togglePdf = () => {
    setModal3(!modal3);
  };
  const [dropdownORG1, setDropdownORG1] = useState(false);
  const [dropdownSub, setDropdownSub] = useState([]);

  const toggleModal = () => {
    setModal(!modal);
    getUserEmployee(cont_to_id);
  };

  const toggleModal2 = () => {
    setModal2(!modal2);
    getUserEmployee(cont_to_id);
  };

  const toggleOrgInner = async () => {
    if (modalORG === false) {
      await getOrgInnerLevel();
      setModalORG(!modalORG);
      orgInner?.child?.map((item) => {
        if (item?.child?.length !== 0) {
          setDropdownSub((prev) => [
            ...prev,
            {
              id: item?.org_id,
              status: false,
            },
          ]);
        }
      });
    } else {
      setModalORG(!modalORG);
      setDropdownSub([]);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const getEmployeeByKongID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      res?.data?.result?.map((item) => {
        setEmployee((prev) => [...prev, item]);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const getEmployeeByGroupID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      res?.data?.result?.map((item) => {
        setEmployee((prev) => [...prev, item]);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const findByOrgKong = (id) => {
    setOrgInnerGroup(
      orgInnerKong.find((item) => item.org_id === parseInt(id))?.child
    );
  };

  const findEmployeeOfKong = (id) => {
    if (id) {
      setEmployee([]);
      let ArrayGroupId =
        orgInnerKong.find((item) => item.org_id === parseInt(id))?.child
          ?.length === 0
          ? id
          : orgInnerKong.find((item) => item.org_id === parseInt(id))?.child;
      if (Array.isArray(ArrayGroupId)) {
        ArrayGroupId?.map((item) => {
          getEmployeeByKongID(item?.org_id);
        });
      } else {
        getEmployeeByKongID(ArrayGroupId);
      }
    }
  };

  const findByOrgGroup = (id) => {
    let anw = orgInnerKong?.find((i) =>
      i?.child?.find((j) => Number(j?.org_id) === Number(id))
    )?.org_id;

    setCheckValueOrgKong((prev) => [...prev, anw]);

    // setOrgInnerGroup(

    let newobject = {
      org_id: id,
      parent_id: anw,
    };

    setCheckValueOrgGroup((prev) => [...prev, newobject]);
  };

  const findEmployeeOfGroup = (id) => {
    if (id) {
      setEmployee([]);
      getEmployeeByGroupID(id);
    }
  };

  const [getLoading, setGetLoading] = useState()
  const getEmployee = async (id) => {
    setGetLoading(true)
    let OrgId = id || "";
    try {
      const url = baseURL + "/api/users/datatable";
      let params = new URLSearchParams({
        page: 1,
        size: 1000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": OrgId,
        search: enterKeyword,
      });
      if (OrgId === undefined) {
        params.delete("filter[cont_to_id][0]", OrgId)
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setEmployee(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
    setTimeout(() => {
      setGetLoading(false)
    }, 1000);
  };

  const getOrgInnerKong = async () => {
    try {
      const res = await axios.get(baseURL + `/api/orgInner/level`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOrgInnerKong(res?.data?.result?.child);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchEvaluateApprove = (id) => {
    const urlCheckRound = `${baseURL}/api/evaluateSalary/checkRound`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios.get(urlCheckRound, config).then((response) => {
      setBudgetForDefault(response.data.result.this_budget_year);
    });
  };

  useEffect(() => {
    getEmployee();
    getOrgInnerKong();
    fetchEvaluateApprove();
  }, []);

  useEffect(() => {
    getEmployee();
  }, [enterKeyword]);

  const CheckListUser = (value) =>{setCheckDisbleButton(value)}

  const [checkDisable, setCheckDisble] = useState(true);
  const [adminOn, setAdminOn] = useState(false);
  const [checkDisableGroup, setCheckDisbleGroup] = useState(true);
  const [checkDisableUser, setCheckDisbleUser] = useState(true);
  const [checkValueOrgKong, setCheckValueOrgKong] = useState([]);
  const [checkValueUniqueOrgKong, setCheckValueUniqueOrgKong] = useState([]);
  const [checkValueOrgGroup, setCheckValueOrgGroup] = useState([]);
  const checkPosition = async () => {
    if (userInfo !== null && userInfo !== undefined) {
      if (userInfo?.positionSubAdmin !== undefined && userInfo?.positionSubAdmin.length > 0) {
        await userInfo.positionSubAdmin.map((i) => {
          if (Number(i.type_sub_admin) === 0 || Number(i.type_sub_admin) === 1) {
            setCheckDisble(false);
            setCheckDisbleGroup(false);
            setCheckDisbleUser(false);
            setAdminOn(true);
          }
        });
      } else {
        if (userInfo.position.length > 0) {
          await userInfo.position.map((item) => {
            if (Number(item.position_id) === 5) {
              setCheckValueOrgKong((prev) => [...prev, item.org_id]);
              setCheckDisble(false);
              findByOrgKong(item.org_id);
              findEmployeeOfKong(item.org_id);
            }

            if (Number(item.position_id) === 7) {
              // setCheckValueOrgGroup((prev) => [...prev, item.org_id]);
              setCheckDisble(false);
              setCheckDisbleGroup(false);
              setCheckDisbleUser(false);
              findByOrgGroup(item.org_id);
            }

            if (Number(item.position_id) === 8) {
              setSearchData((prev) => ({
                ...prev,
                empName: userInfo.user_id,
                empNamID: userInfo.user_name,
              }));
            }
          });
        } else {
          setSearchData((prev) => ({
            ...prev,
            empName: userInfo.user_id,
            empNamID: userInfo.user_name,
          }));
        }
      }
    }
  };

  useEffect(() => {
    if (userInfo.length !== 0) {
      checkPosition();
    }
  }, [userInfo]);

  useEffect(() => {
    const uniqueDataSet = [...new Set(checkValueOrgKong)];
    setCheckValueUniqueOrgKong(uniqueDataSet);
  }, [checkValueOrgKong]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1800);
  }, []);

  const handleSearch = () =>{
    setEnterKeyword(keyword)
  }

  const insertSearchReportFromDate = (event) =>{
    setSearchReport((prev) => ({
      ...prev,
      fromDate: event,
    }));
  }

  const insertSearchReportToDate = (event) =>{
    setSearchReport((prev) => ({
      ...prev,
      toDate: event,
    }));
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const setDivisionOrg =(event)=>{
    setSearchData((prev) => ({ ...prev, department: event}));
    setSearchData((prev) => ({ ...prev, groupName: ""}));
  }

  const setGroupOrg =(event)=>{
    setSearchData((prev) => ({ ...prev, groupName: event}));
  }

  const setUserOrg =(event,eventid)=>{
    setSearchData((prev) => ({
      ...prev,
      empName: event,
      empNamID: eventid,
    }));
  }
  // const [arrayOrgGroup, setArrayOrgGroup] = useState(null)
  // const [arrayPushOrgGroup, setArrayPushOrgGroup] = useState(null)
  // useEffect(() => {
  //   if (arrayOrgGroup !== null) {
  //    let arrayPop = []
  //      arrayOrgGroup?.map(i=>(
  //        arrayPop.push(i?.org_id)
  //      ))
  //      setArrayPushOrgGroup(arrayPop)
  //   }
  //  }, [arrayOrgGroup])

  return (
    <Fragment>
      {loading ? (
        <div>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: loadingLeaveTap.default,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            width={250}
            height={250}
          />
        </div>
      ) : (
        <div>
          <ModalCardLeave
            searchReport={searchReport}
            cardLeave={cardLeave}
            handleOpenCardLeave={handleOpenCardLeave}
            budGetYear={
              searchReport?.budget_year === ""
                ? budgetForDefault
                : searchReport?.budget_year
            }
            userID={
              searchData?.empName === "" ? user.user_id : searchData?.empName
            }
            userName={
              searchData?.empName === "" ? user.user_name : searchData?.empNamID
            }
            leaveTypeHistory={leaveTypeHistory}
            monthOn={searchReport?.month}
          />
          <ModalSummaryLeaveDay
            modalSummaryLeaveDay={modalSummaryLeaveDay}
            toggleModalSummaryLeaveDay={toggleModalSummaryLeaveDay}
            departMent={searchData?.department}
            budGetYear={searchReport?.budget_year}
            userId={searchData?.empName}
            dmyStart={searchReport?.fromDate}
            dmyEnd={searchReport?.toDate}
            userEmployeeTypeId={searchReport?.employeeType}
            orgId={searchData?.groupName}
          />
          <Form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="mt-3"
          >
            {idReport === "1" ||
            idReport === "2" ||
            idReport === "3" ||
            idReport === "5" ? (
              <FormGroup className="" row>
                <Label className="text-end" xxl={4} xl={4} xs={4}>
                  ปีงบประมาณ
                </Label>
                <Col xxl={8} xl={8} xs={8}>
                  <Input
                    type="select"
                    value={searchReport?.budget_year}
                    onChange={(e) => {
                      setSearchReport((prev) => ({
                        ...prev,
                        budget_year: e.target.value,
                      }));
                    }}
                  >
                    <option value={budgetYear - 0}>{budgetYear - 0}</option>
                    <option value={budgetYear - 1}>{budgetYear - 1}</option>
                    <option value={budgetYear - 2}>{budgetYear - 2}</option>
                    <option value={budgetYear - 3}>{budgetYear - 3}</option>
                    <option value={budgetYear - 4}>{budgetYear - 4}</option>
                    <option value={budgetYear - 5}>{budgetYear - 5}</option>
                  </Input>
                </Col>
              </FormGroup>
            ) : null}
            {idReport === "1" || idReport === "5" ? (
              <FormGroup className="" row>
                <Label className="text-end" xxl={4} xs={4}>
                  เดือน
                </Label>
                <Col xl={8} xs={8}>
                  <Input
                    type="select"
                    value={searchReport?.month}
                    onChange={(e) => {
                      setSearchReport((prev) => ({
                        ...prev,
                        month: e.target.value,
                      }));
                    }}
                  >
                    <option value="">ทั้งหมด</option>
                    {MonthName.map((item, idx) => {
                      return (
                        <option key={idx} value={item.no}>
                          {item.name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </FormGroup>
            ) : null}

            {idReport === "2" || idReport === "3" ? (
              <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                <Col xs={12} xxl={6} className="mt-1">
                  <Row>
                    <Label className="text-end" xxl={4} xs={4}>
                      ช่วงวันที่
                    </Label>
                    <Col xxl={8} xs={8}>
                      <NewThaiDatePicker value={searchReport.fromDate} setValue={insertSearchReportFromDate} placeholderText="วัน/เดือน/ปี"/>
                    </Col>
                  </Row>
                </Col>
                <Col xxl={6} xs={12} className="mt-1">
                  <Row>
                    <Label className="text-end" xxl={4} xs={4}>
                      ถึงวันที่
                    </Label>
                    <Col xxl={8} xs={8}>
                      <NewThaiDatePicker value={searchReport.toDate} setValue={insertSearchReportToDate} placeholderText="วัน/เดือน/ปี"/>
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
            ) : null}
            {idReport === "3" ? (
              <Fragment>
                <FormGroup row>
                        <Label className="text-end" xl={4} xs={4}>
                          ประเภทเจ้าหน้าที่
                        </Label>
                        <Col xl={8} xs={8}>
                          <Input
                            type="select"
                            onChange={(e) => {
                              setSearchReport((prev) => ({
                                ...prev,
                                employeeType: e.target.value,
                              }));
                            }}
                          >
                            <option value="">กรุณาระบุ</option>
                            <option value="1">ข้าราชการ</option>
                            <option value="2">ลูกจ้างชั่วคราว</option>
                            <option value="3">นักบริหารการเปลี่ยนแปลงรุ่นใหม่</option>
                          </Input>
                        </Col>
                </FormGroup>
                <SelectOrg setDivisionOrg={setDivisionOrg} setGroupOrg={setGroupOrg} setUserOrg={setUserOrg} task="have option" sizeXs = {12} sizeMd = {12} sizeXl = {12} notAdAll={false} functionCheck={CheckListUser} checkLeave={true}/>
              </Fragment>
            ) : null}
            {idReport === "1" || idReport === "2" ? (
              (CheckPosition(userPosition).length > 0 && !userPosition?.some(item => item.position_id === 8)) || 
              (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
              (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
               CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))) 
               ? 
                <SelectOrg setDivisionOrg={setDivisionOrg} setGroupOrg={setGroupOrg} setUserOrg={setUserOrg} task="have option" sizeXs = {12} sizeMd = {12} sizeXl = {12} notAdAll={true} functionCheck={CheckListUser} checkLeave={true}/>
              : ""
            ) : null}
            {idReport === "1" || idReport === "3" || idReport === "5" ? (
              <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                <Col xxl={4} lg={4} md={4} sm={4} xs={4}>
                  <Button
                    color="success"
                    className="w-100"
                    disabled={checkDisbleButton}
                    onClick={() => {
                      if (idReport === "1") {
                        handleOpenCardLeave();
                      }
                      if (idReport === "3") {
                        toggleModalSummaryLeaveDayOpen();
                      }
                    }}
                  >
                    ค้นหา
                  </Button>
                </Col>
                <Col xxl={4} lg={4} md={4} sm={4} xs={4}>
                  <Button color="danger" className="w-100">
                    ยกเลิก
                  </Button>
                </Col>
              </FormGroup>
            ) : null}
            {idReport === "2" ? (
              <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                <Col xxl={4} xs={8}>
                  <Button
                    color="success"
                    className="w-100"
                    disabled={
                      searchReport.fromDate === "" ||
                      searchReport.toDate === "" ||
                      searchReport.budget_year === ""
                    }
                    onClick={togglePdf}
                  >
                    พิมพ์
                  </Button>
                </Col>
              </FormGroup>
            ) : null}
          </Form>
          <Modal centered isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>เลือกเจ้าหน้าที่</ModalHeader>
            <ModalBody>
              {employee?.length > 0 && getLoading === false ? 
                <Fragment>
                  <FormGroup>
                    <Col>
                      <InputGroup>
                        <Input
                            type="search"
                            placeholder="ค้นหาพนักงาน..."
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                          <Button onClick={handleSearch}>
                            <i className="fa-solid fa-magnifying-glass p-1"></i>
                          </Button>
                      </InputGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col>
                      <Input
                        value={searchData?.empName}
                        style={{ height: "400px" }}
                        multiple
                        type="select"
                        onChange={(e) => {
                          setSearchData((prev) => ({
                            ...prev,
                            empName: e.target.value,
                            empNamID: e.target.options[e.target.selectedIndex].text,
                          }));
                          toggleModal();
                        }}
                      >
                          {employee?.map((item) => {
                            return (
                              <option key={item?.user_id} value={item?.user_id}>
                                {item?.user_name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                  </FormGroup>
                </Fragment>
              : <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loadingLeaveTap.default,
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  width={250}
                  height={250}
                /> 
              }
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                onClick={()=>{
                  setEnterKeyword("")
                  setKeyword("")
                  setSearchData((prev) => ({
                    ...prev,
                    empName: "",
                    empNamID: "",
                  }));
                }}
              >
                ล้างการค้นหา
              </Button>
            </ModalFooter>
          </Modal>
          <Modal centered isOpen={modal3} toggle={togglePdf} size="xl">
            <ModalHeader toggle={togglePdf}></ModalHeader>
            <ModalBody style={{ overflowX: "scroll"}}>
              <Bookcertificate
                dateFrom={searchReport.fromDate}
                dateTo={searchReport.toDate}
                budYear={searchReport.budget_year}
                userID={searchData?.empName}
              />
            </ModalBody>
          </Modal>
        </div>
      )}
    </Fragment>
  );
};

export default SelectReport;
